import React, { useState, useEffect, useRef } from 'react'
import { MuiThemeProvider } from '@material-ui/core/styles'
import MaterialTable, { MTableCell } from '@material-table/core'
import { table } from '../../services/theme'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ScheduledVisitsToolbar } from './Toolbars/Schedule/ScheduledVisitsToolbar'
import moment from 'moment'


export const ScheduledVisitsTable = (props) => {
	const history = useHistory()
	const tableRef = useRef(null)
	const toolbarRef = useRef(null)

	const visitsLoading = useSelector((state) => state.specific.visits.loading)

	const [loading, setLoading] = useState(false)

	useEffect(() => {
		if (visitsLoading) {
			setLoading(true)
		} else {
			setLoading(false)
		}
	}, [visitsLoading])

	let { date, scheduleAggregates, setDate, changeDate } = props

	return (
		<MuiThemeProvider theme={table}>
			<ScheduledVisitsToolbar
				ref={toolbarRef}
				tableRef={tableRef}
				date={date}
				grooming={props.grooming}
				scheduleAggregates={scheduleAggregates}
				setDate={setDate}
				changeDate={changeDate}
			/>
			<MaterialTable
				tableRef={tableRef}
				options={{
					sorting: true,
					toolbar: false,
					headerStyle: {
						color: '#1A1A35',
						textTransform: 'uppercase',
						fontWeight: 800,
						fontSize: '12px',
						lineHeight: '16px',
						padding: '11px 24px',
						borderTop: '1px solid #D0CFD2',
						backgroundColor: '#F9F9F9'
					},
					rowStyle: {
						verticalAlign: 'top',
						width: '100%',
					},
					pageSize: 10,
					pageSizeOptions: [10, 20, 50],
					toolbarButtonAlignment: 'left',
					searchFieldAlignment: 'left'
				}}
				isLoading={loading}
				columns={props.columns}
				data={props.data}
				onRowClick={(e, visit) =>
					history.push(
						`/clients/${visit.household_id}/appointments/${visit._id}${`?date=${moment(date).format(
							'YYYYMMDD'
						)}`}`
					)
				}
				components={{
					Cell: (props) => {
						return(
							<MTableCell
								style={{
									borderBottom: 'none',
									padding: '16px 36px 16px 24px'
								}}
								{...props}
							/>
						)
					},
				}}
				title={props.grooming ? 'Grooming Schedule' : "Pet Care Schedule"}
			/>
		</MuiThemeProvider>
	)
}
